import * as React from 'react';
import { useContext } from 'react';

export type StickyPanelContextType = {
  zIndex?: number;
  updateHasOpenModal?: (hasOpenModal?: boolean) => void;
};

const StickyPanelContext = React.createContext<StickyPanelContextType>({});

export const useStickyPanel = () => {
  return useContext(StickyPanelContext);
};

export default StickyPanelContext;
